require('./dist/icon-button/icon-button.css');
